import { getFolders } from 'owa-todo-folders';

export function getDefaultFolderId(): string | null {
    const folders = getFolders();
    const defaultFolder = folders.filter(folder => folder.IsDefaultFolder);
    return defaultFolder.length > 0 ? defaultFolder[0].Id : null;
}
